import { NavLink } from 'react-router-dom'
import { LayoutDashboard, ClipboardList, Kanban, Truck, Settings, Plus, LogOut, Wrench, BarChart3, Users, DollarSign, Sparkles, Wallet, Store, ShieldCheck, Archive } from 'lucide-react'
import { useAuth } from '../../contexts/AuthContext'

// 11 links — ícone + texto SEMPRE visíveis em ≥md (768px). Em mobile some o
// texto pra evitar overflow. Padding e fonte compactos pra caber em laptops
// comuns (1280–1440px) sem scroll lateral.
const links = [
  { to: '/',                   label: 'Início',    icon: LayoutDashboard },
  { to: '/pedidos',            label: 'Pedidos',   icon: ClipboardList   },
  { to: '/kanban',             label: 'Kanban',    icon: Kanban          },
  { to: '/logistica',          label: 'Logística', icon: Truck           },
  { to: '/dashboards',         label: 'Dashboards',icon: BarChart3       },
  { to: '/clientes',           label: 'Clientes',  icon: Users           },
  { to: '/comissoes',          label: 'Comissões', icon: DollarSign      },
  { to: '/contas-a-receber',   label: 'A receber', icon: Wallet          },
  { to: '/oportunidades-arco', label: 'Arco',      icon: Sparkles        },
  { to: '/marketplace',        label: 'Marketplace',icon: Store          },
  { to: '/custo',              label: 'Formini',   icon: Wrench          },
  { to: '/config',             label: 'Config',    icon: Settings        },
  // Lixeira (/lixeira) e Admin (/admin/usuarios) NÃO ficam na navbar
  // pra não poluir. Acessa direto pela URL — só admin/gerente conseguem
  // (as próprias páginas fazem o gate por role).
]

export function Navbar() {
  const { user, profile, logout } = useAuth()

  return (
    <nav className="fixed top-0 left-0 right-0 z-40 bg-[#111111] h-14 hidden md:flex items-center px-3 gap-2 shadow-lg">
      {/* Logo — texto MINI/DECK aparece a partir de lg pra dar espaço aos links */}
      <NavLink to="/" className="flex items-center shrink-0">
        <img
          src="/logo-mini.svg"
          alt="Mini Marcenaria"
          className="h-9 w-9 rounded-lg object-contain bg-[#111111]"
        />
        <div className="ml-2 leading-none hidden lg:block">
          <div className="text-white font-black text-sm tracking-widest uppercase">MINI</div>
          <div className="text-[#F5C200] font-semibold text-[8px] tracking-[0.22em] uppercase mt-0.5">
            DECK
          </div>
        </div>
      </NavLink>

      {/* Links — ícone + texto sempre visíveis em ≥md.
          Padding e fonte enxutos pra caber tudo numa linha sem overflow. */}
      <div className="flex items-center gap-0 flex-1 justify-center min-w-0">
        {links.filter(l => {
          if (l.adminOnly)   return profile?.role === 'admin'
          if (l.gerenteOnly) return profile?.role === 'admin' || profile?.role === 'gerente'
          return true
        }).map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            title={label}
            className={({ isActive }) =>
              `flex items-center gap-1.5 px-2 py-1.5 rounded-lg text-[12px] font-medium transition-colors shrink-0 whitespace-nowrap
               ${isActive
                 ? 'bg-[#F5C200]/15 text-[#F5C200]'
                 : 'text-gray-400 hover:bg-white/10 hover:text-white'
               }`
            }
          >
            <Icon size={15} />
            <span className="hidden md:inline">{label}</span>
          </NavLink>
        ))}
      </div>

      {/* Novo Pedido — label aparece a partir de lg */}
      <NavLink
        to="/pedido/novo"
        title="Novo Pedido"
        className="btn-primary text-sm no-underline shrink-0"
      >
        <Plus size={15} />
        <span className="hidden lg:inline">Novo Pedido</span>
      </NavLink>

      {user && (
        <div className="flex items-center gap-2 pl-2 ml-1 border-l border-white/10 shrink-0">
          <span className="text-slate-400 text-xs hidden 2xl:block">{profile?.username || profile?.nome}</span>
          <button
            onClick={logout}
            title="Sair"
            className="p-1.5 rounded-lg text-slate-400 hover:bg-white/10 hover:text-white transition-colors"
          >
            <LogOut size={15} />
          </button>
        </div>
      )}
    </nav>
  )
}
